export function isPlaceholderSectionLabel(value) {
  const text = String(value || '').trim();
  if (!text) return false;
  return /^(nuevo\s+bloque|bloque|lugar)(\s+\d+)?$/i.test(text);
}

export function getSectionTitle(section, defaultSection) {
  const title = String(section?.title || '').trim();
  if (title && !isPlaceholderSectionLabel(title)) return title;
  const name = String(section?.name || '').trim();
  if (name && name !== defaultSection && !isPlaceholderSectionLabel(name)) return name;
  return '';
}

export function getSectionNote(section) {
  return String(section?.note || '').trim();
}

export function getSectionTime(section) {
  return String(section?.time_text || '').trim();
}

export function getSectionViewState({
  section,
  sectionItems = [],
  defaultSection,
  canEdit,
  isSearchActive,
  isRenamingSection,
  isEditingSectionMeta,
  isEditingSectionNote,
  isSectionSelected,
  isPreservedEmptySection,
}) {
  const displaySectionTitle = getSectionTitle(section, defaultSection);
  const displaySectionNote = getSectionNote(section);
  const displaySectionTime = getSectionTime(section);
  const isDefaultSection = section?.name === defaultSection;
  const isEditing = Boolean(isSearchActive || isRenamingSection || isEditingSectionMeta || isEditingSectionNote);
  const isSectionActive = Boolean(isEditing || isSectionSelected);
  const hasSectionMeta = isDefaultSection
    ? Boolean(displaySectionNote)
    : Boolean(displaySectionTitle || displaySectionNote || displaySectionTime);
  const hasVisualContent = sectionItems.length > 0 || hasSectionMeta;
  const isStatusOnly = section?.kind === 'status'
    && sectionItems.length === 0
    && Boolean(displaySectionNote)
    && !isSearchActive
    && !isRenamingSection;

  const shouldRenderSection = hasVisualContent
    || isEditing
    || (isPreservedEmptySection && (hasSectionMeta || isEditing));

  const showSectionHeader = shouldRenderSection
    && !isDefaultSection
    && !isStatusOnly
    && (
      isRenamingSection
      || isEditingSectionMeta
      || isSectionActive
      || Boolean(displaySectionTitle || displaySectionTime)
    );

  return {
    displaySectionTitle,
    displaySectionNote,
    displaySectionTime,
    isDefaultSection,
    isSectionActive,
    isStatusOnly,
    hasSectionMeta,
    hasVisualContent,
    shouldRenderSection,
    showSectionHeader,
    showAssignmentSearch: canEdit && isSectionActive && !isEditingSectionNote,
    canEditSectionMeta: canEdit && !isDefaultSection,
    canMoveDeleteSection: canEdit && Boolean(section?.id || sectionItems.length > 0 || hasSectionMeta),
    canDeleteWholeSection: !isDefaultSection || Boolean(section?.id || sectionItems.length > 0 || hasSectionMeta),
    isFramed: Boolean(isEditing || showSectionHeader || hasSectionMeta || sectionItems.length > 0),
    isEmptyNamedSection: Boolean(
      section?.id
      && !isDefaultSection
      && !displaySectionTitle
      && !displaySectionNote
      && !displaySectionTime
      && sectionItems.length === 0
    ),
  };
}
